// extracted by mini-css-extract-plugin
export var accordionItem = "accordion-module--accordion-item--1eb5e";
export var active = "accordion-module--active--2aeab";
export var answer = "accordion-module--answer--3cf70";
export var backToTop = "accordion-module--back-to-top--3677b";
export var closed = "accordion-module--closed--bd182";
export var question = "accordion-module--question--6176a";
export var questionHeader = "accordion-module--question-header--f07a5";
export var questions = "accordion-module--questions--2842a";
export var wrap = "accordion-module--wrap--3019f";